/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BazosInputs */

const cs_enum_bazos = /** @type {(inputs: Enum_BazosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bazoš`)
};

const en_enum_bazos = /** @type {(inputs: Enum_BazosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bazos`)
};

/**
* | output |
* | --- |
* | "Bazos" |
*
* @param {Enum_BazosInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_bazos = /** @type {((inputs?: Enum_BazosInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BazosInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_bazos(inputs)
	return cs_enum_bazos(inputs)
});